// Custom packages
import { DocumentArchiveTree } from "src/app/shared/interfaces/document-archive-doc.interface";

/**
 * Section of the 3.0.0 tree holding the lease contracts: the counterpart of the legacy
 * `locazioneContrdiLocazione` category, with the same correspondence the back-end uses for the
 * public QR pages.
 *
 * @since 3.0.0
 */
export const LEASE_CONTRACTS_SECTION_TITLE = "tenancyContracts";

/**
 * Whether the new archive tree holds a lease contract: a filed, non-deleted row in the
 * "tenancyContracts" section — the 3.0.0 counterpart of `hasLeaseContractDocuments`,
 * which reads the legacy `locazioneContrdiLocazione` section. Expired rows count, as there.
 *
 * A row must be `present`: the legacy route only sends entries holding a document, so the empty
 * row of an obligation does not count.
 *
 * @since 3.0.0
 */
export function treeHasLeaseContract(tree: DocumentArchiveTree | null | undefined): boolean {
  if (!tree || !Array.isArray(tree.area)) {
    return false;
  }
  return tree.area.some((area) =>
    !!area &&
    Array.isArray(area.content) &&
    area.content.some((content) =>
      !!content &&
      content.title === LEASE_CONTRACTS_SECTION_TITLE &&
      Array.isArray(content.groups) &&
      content.groups.some((group) =>
        !!group &&
        Array.isArray(group.documents) &&
        group.documents.some((doc) =>
          !!doc &&
          Array.isArray(doc.archiveDocs) &&
          doc.archiveDocs.some((row) => !!row && row.present === true && row.deleted !== true)
        )
      )
    )
  );
}
